import { Flex, FlexProps, Title } from '@mantine/core';
import { PropsWithChildren } from 'react';

type Props = FlexProps & {
	title?: string;
};

export const ContentSection = ({ children, ...props }: PropsWithChildren<Props>) => {
	return (
		<Flex direction="column" m="md" justify="flex-start" h="100%" w="100%" {...props}>
			{props.title && (
				<Title order={2} mb={10} fw={900}>
					{props.title}
				</Title>
			)}
			{children}
		</Flex>
	);
};
